/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-lonely-if */
import i18n from 'i18next';
import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StorageHelper } from '../../utils/StorageHelper';
import { useAuthStore } from '../../store/AuthContext';
import NotFound from '../NotFound';
import { GtmConstants } from '../../utils/GtmConstants';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import { CookieHelper } from '../../utils/CookieHelper';
import TitularCaprabo from './Titular/indexCaprabo';
import NoTitularCaprabo from './NoTitular/indexCaprabo';
import CotitularCaprabo from './Cotitular/indexCaprabo';
import { BackMappings } from '../../utils/BackMappings';
import useSessionChecking from '../../hooks/useSessionChecking';
import { TarjetaService } from '../../services';
import useAPIError from '../../hooks/useAPIError';
import AdicionalCaprabo from './Adicional';
import { SessionChecker } from '../../utils/SessionChecker';
import { CryptoUtil } from '../../utils/CryptoUtil';

const TarjetasCaprabo: FC = () => {
  useDatalayerEvents(GtmConstants.MI_CUENTA);
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [cardNumberShort, setCardNumberShort] = useState<string>();
  const [controlDigit, setControlDigit] = useState<string>();

  const shouldGetCardNumber = () => {
    return (
      !CookieHelper.isBloqueada() &&
      dataUser.user.titular &&
      !StorageHelper.isForzeSinTarjetas()
    );
  };

  const getCardNumber = () => {
    if (shouldGetCardNumber()) {
      TarjetaService.getTarjeta()
        .then((response) => {
          if (
            response.data.error &&
            response.data.errorCode === BackMappings.GO_TO_RELOGIN
          ) {
            SessionChecker.closeSessionAndGoToReLogin(null, i18n.language);
          } else {
            if (response.data.error) {
              setLoad(false);
              addErrorBack(response.data);
            } else {
              setCardNumberLong(
                CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
              );
              setCardNumberShort(
                CryptoUtil.decryptAes(response.data.pojo.cardNumberShort),
              );
              setControlDigit(
                CryptoUtil.decryptAes(response.data.pojo.controlDigit),
              );
            }
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
  };
  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
      setLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });

  if (goOn) {
    if (load) {
      if (CookieHelper.isBloqueada()) {
        return (
          <>
            <NotFound />
          </>
        );
      }
      if (dataUser.user.isEmpresa && !dataUser.user.titular) {
        return (
          <>
            <NotFound />
          </>
        );
      }

      if (StorageHelper.isForzeSinTarjetas()) {
        return (
          <>
            <NoTitularCaprabo />
          </>
        );
      }
      if (dataUser.user.titular && !dataUser.user.adicional) {
        return (
          <>
            <TitularCaprabo
              cardNumberLong={cardNumberLong}
              load={load}
              cardNumberShort={cardNumberShort}
              controlDigit={controlDigit}
            />
          </>
        );
      }
      if (dataUser.user.adicional) {
        return (
          <>
            <AdicionalCaprabo cardNumberLong={cardNumberLong} load={load} />
          </>
        );
      }
      if (!dataUser.user.titular && !dataUser.user.adicional) {
        return (
          <>
            <NoTitularCaprabo />
          </>
        );
      }
      return <></>;
    }
    return <></>;
  }
  return <></>;
};
export default TarjetasCaprabo;
